import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '@app/shared/services/auth.service';
import { TransitionService, UIRouterGlobals } from '@uirouter/angular';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicHeaderComponent {
  private readonly $transitions = inject(TransitionService);
  private readonly auth = inject(AuthService);
  private readonly routerGlobals = inject(UIRouterGlobals);
  private readonly domSanitizer = inject(DomSanitizer);
  loginUrl = toSignal(this.auth.LOGIN_LINK.pipe(map(link => this.domSanitizer.bypassSecurityTrustUrl(link))));
  showHeader = signal(false);

  constructor() {
    this.updateHeaderForState(this.routerGlobals.current);
    this.$transitions.onSuccess({}, transition => {
      this.updateHeaderForState(transition.to());
    });
  }

  updateHeaderForState(state) {
    this.showHeader.set(state?.data?.showHeader); // By default, false
  }
}
